import NewsletterInputEmailProvider from './hooks/useNewsletterInputEmail';

import { NewsletterInputEmailProps } from './@types/NewsletterInputEmailProps';
import NewsletterInputEmailContainer from './handles/NewsletterInputEmailContainer';

const NewsletterInputEmail = (props: NewsletterInputEmailProps) => (
	<NewsletterInputEmailProvider {...props}>
		<NewsletterInputEmailContainer />
	</NewsletterInputEmailProvider>
);

export default NewsletterInputEmail;
